import { createSelector } from 'reselect'
import { INSTANCE_NAME, SELECTOR_NAME } from 'src/features/AccountSearch/constants'

const defaultAccs = []

export const isAccountSearchLoading = ({ accountSearch }, selector: boolean) => {
  const state = selector ? SELECTOR_NAME : INSTANCE_NAME
  if (accountSearch) {
    return accountSearch?.status[state] === 'loading'
  }

  return false
}

export const getAccountSearchData = ({ accountSearch }, selector: boolean) => {
  const state = selector ? SELECTOR_NAME : INSTANCE_NAME
  return accountSearch?.data[state] || defaultAccs
}

export const getAccsFetchSucceeded = ({ accountSearch }, selector: boolean) => {
  const state = selector ? SELECTOR_NAME : INSTANCE_NAME
  return accountSearch?.status[state] === 'loaded'
}

// export const getAccounts = (state, selector) => {
//   const fetcherState = selector ? SELECTOR_NAME : INSTANCE_NAME
//   return state[fetcherState]
// }

export const getAccountsCount = createSelector(getAccountSearchData, (accounts) => accounts.length)
